import React from 'react';
import styled from 'styled-components';
import Intl from 'src/components/Intl';

import Card from 'components/Card';

function Stories() {
  return (
    <Intl>
      {(t, { locale }) => {
        return (
          <Root>
            <Card
              title={t.stories.card1.title}
              content={t.stories.card1.content}
              backgroundColor="#E5E4E5"
              imageSrc={require('src/assets/images/Invest_In_Time.jpg')}
              backgroundPosition='bottom center'
              caption={t.stories.card1.caption}
            />
            <Card
              title={t.stories.card2.title}
              content={t.stories.card2.content}
              backgroundColor="#E5E4E5"
              imageSrc={require('src/assets/images/Invest_In_Vision.jpg')}
              isReverseOrederDesktop
              backgroundPosition='top center'
              caption={t.stories.card2.caption}
            />
            <Card
              title={t.stories.card3.title}
              content={t.stories.card3.content}
              backgroundColor="#E5E4E5"
              imageSrc={require('src/assets/images/Invest_In_Home.jpg')}
              caption={t.stories.card3.caption}
              backgroundPosition='center center'
            />
          </Root>
        );
      }}
    </Intl>
  );
};


const Root = styled.section``;

export default Stories

